<div class="flex justify-between items-center">
  <div class="tabs">
    <a
      class="tab tab-bordered"
      [class.tab-active]="activeTab() === 0"
      (click)="onSelectTab(0)"
      >eJournal</a
    >
    <a
      class="tab tab-bordered"
      [class.tab-active]="activeTab() === 1"
      [class.tab-disabled]="!journal()"
      (click)="onSelectTab(1)"
      >Signers</a
    >
    <a
      class="tab tab-bordered"
      [class.tab-active]="activeTab() === 2"
      [class.tab-disabled]="!journal()"
      (click)="onSelectTab(2)"
      >{{ journal()?.isFinal ? 'Entries' : 'eSeals' }}</a
    >
  </div>
  <et-journal-finalize-btn></et-journal-finalize-btn>
</div>

<!-- Tabs content -->
<div
  class="flex-1 overflow-hidden touch-pan-y"
  (pointerdown)="onPointerDown($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerCancel()"
>
  <div
    class="flex h-full w-full transition-transform duration-300 ease-out"
    [style.transform]="translateStyle()"
  >
    <!-- Tab 1 - Journal Packet Card -->
    <div class="w-full shrink-0 px-1">
      <et-journal-packet-card-wrapper [eJournal]="journal()">
        <et-journal-packet-card></et-journal-packet-card>
      </et-journal-packet-card-wrapper>
    </div>
    <!-- Tab 2 - Journal Signer Card -->
    <div class="w-full shrink-0 px-1">
      <et-journal-signer-card-wrapper
        [isFinalized]="!!journal()?.isFinal"
        [noSigners]="signers().length === 0"
        [isLoading]="signersLoading()"
      >
        @for (signer of signers(); track signer) {
        <et-journal-signer-card
          [signer]="signer"
          [isFinalized]="!!journal()?.isFinal"
        ></et-journal-signer-card>
        }
      </et-journal-signer-card-wrapper>
    </div>
    <!-- Tab 3 - Journal Entry / eSeal Cards -->
    <div class="w-full shrink-0 px-1">
      <!-- Show seals on web only when packet is signed -->
      @if (showESeals()) {
      <et-journal-entry-card-wrapper
        [isFinalized]="isFinalized()"
        [noEntries]="noEntriesContent()"
        [isLoading]="entriesLoading()"
      >
        @if (isFinalized()) { @for (entry of entries(); track
        entry.eJournalEntryId) {
        <et-journal-entry-card
          [entry]="entry"
          [signers]="signers()"
          [isFinalized]="true"
        ></et-journal-entry-card>
        } } @else { @for (seal of seals(); track seal.sealId) {
        <et-journal-seal-card
          [seal]="seal"
          [signers]="signers()"
        ></et-journal-seal-card>
        } @for (entry of cancelActEntries(); track entry.eJournalEntryId) {
        <et-journal-entry-card
          [entry]="entry"
          [signers]="signers()"
          [isFinalized]="false"
        ></et-journal-entry-card>
        } }
      </et-journal-entry-card-wrapper>
      } @else {
      <div class="flex h-72 w-full items-center justify-center">
        <p class="text-center">
          eSeals will not be visible until your package signing is complete.
          Please finish signing all required documents to view your eSeal(s).
        </p>
      </div>
      }
    </div>
  </div>
</div>
